import { ALERT_MAPPING } from './typings/configAlertsTypings'
import { useDismissAlerts, useGetConfigAlerts } from './useConfigAlerts'

export const configAlerts = {
  getAlerts: useGetConfigAlerts,
  dismissAlerts: useDismissAlerts,
  mapping: ALERT_MAPPING,
}

export type {
  AlertMapping,
  AlertSeverity,
  AlertTab,
  ConfigAlert,
  GetConfigAlertsResponse,
} from './typings/configAlertsTypings'
export { ALERT_MAPPING, ANCHOR_LABELS, getAlertMapping } from './typings/configAlertsTypings'
export { CONFIG_ALERTS_QUERY_KEY, useDismissAlerts, useGetConfigAlerts } from './useConfigAlerts'
